<template>
    <div class="content">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('report.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="report-box">
            <div class="muscles-box">
                <div class="muscles-item" :class="{'active' : selectMuscles[index] == 1 }" v-for="(muscles, index) in reportTypeList" @click="clickMuscles(index)">{{muscles.show}}</div>
            </div>
            <div class="msg-box">
                <van-field
                    v-model="message"
                    rows="6"
                    size="large"
                    type="textarea"
                    maxlength="100"
                    :placeholder="$t('report.content')"
                    show-word-limit
                />
            </div>
            <div class="btn-disable" :class="{'able':message.length > 0}" @click="send">{{ $t('feedback.submit') }}</div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import {WebJSBridge} from "../../utils/JSBridge1";
export default {
    name: '01feedback',
    data() {
        return {
            theme: 'light',
            message: '',
            phone: '',
            appVersion: '',
            termModel: '',
            termVersion: '',
            watchModel: '',
            selectMuscles: [0, 0, 0, 0, 0, 0, 0],
            reportTypeList: [
                {
                    type: 0,
                    name: '有害/不安全',
                    show: this.$t('report.type[0]')
                },
                {
                    type: 1,
                    name: '色情低俗',
                    show: this.$t('report.type[1]')
                },
                {
                    type: 2,
                    name: '谩骂攻击',
                    show: this.$t('report.type[2]')
                },
                {
                    type: 3,
                    name: '违法犯罪',
                    show: this.$t('report.type[3]')
                },
                {
                    type: 4,
                    name: '隐私相关',
                    show: this.$t('report.type[4]')
                },
                {
                    type: 5,
                    name: '侵犯我的著作权、名誉权等',
                    show: this.$t('report.type[5]')
                },
                {
                    type: 6,
                    name: '其他',
                    show: this.$t('report.type[6]')
                }
            ],
            reportContent: '',
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
        this.appVersion = this.$route.query.appVersion;
        this.termModel = this.$route.query.termModel;
        this.termVersion = this.$route.query.termVersion;
        this.watchModel = this.$route.query.watchModel;
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        clickMuscles(index) {
            if (this.selectMuscles[index] == 1) {
                this.$set(this.selectMuscles, index, 0);
            } else {
                this.$set(this.selectMuscles, index, 1);
            }
        },
        send() {
            let trainMuscles = [];
            for (let i = 0; i < this.selectMuscles.length; i++) {
                if (this.selectMuscles[i] == 1) {
                    trainMuscles.push(this.reportTypeList[i].name);
                }
            }
            if (this.message) {
                this.$api.my.uploadAppLog({
                    describe: this.message,
                    reportType: trainMuscles.toString()
                }).then(res => {
                    Toast.success('提交成功');
                    this.showReport = false;
                    this.$router.back()
                })
            }
        }
    }
}
</script>

<style scoped>

.muscles-box {
    width: 345px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.muscles-item {
    background-color: var(--bg-color-2);
    color: var(--text-color-2);
    border-radius: 15px 15px 15px 15px;
    padding: 8px 14px;
    font-size: 12px;
    margin-right: 4px;
    margin-bottom: 8px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.muscles-item.active {
    background-color: #DAEDE5;
    color: var(--chart-color-1);
}

.report-title {
    font-size: 15px;
    color: var(--text-color-1);
    text-align: center;
    margin-bottom: 20px;
}

.report-box {
    padding: 10px 0 0;
}

.msg-box {
    width: 345px;
    height: 189px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 11px auto 0;
    overflow: hidden;
    font-size: 15px;
}

/deep/ .report-box .van-cell {
    padding: 16px 20px;
    background-color: var(--bg-color-2);
}

.btn-disable {
    width: 345px;
    height: 52px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
    color: var(--text-color-3);
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 17px;
    border: 2px solid var(--bg-color-2);
}

/deep/ .van-field__control {
    font-size: 15px;
    color: var(--text-color-1);
    letter-spacing: 0.5px;
}

.able {
    border: 2px solid var(--text-color-1);
    color: var(--text-color-1);
}
</style>



// WEBPACK FOOTER //
// src/views/my/05report.vue